require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-important-message-2-16-21.json") })
        }
      }, "path---articles-important-message-2-16-21");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-important-message-2-16-21!./.cache/json/articles-important-message-2-16-21.json
// module id = 1690
// module chunks = 231608221292675